<template>
	<div class="form">
		<div class="delete" v-if="canDelete" @click="confirm"></div>

		<b-form-row>
			<b-col cols="12">
				<input-component name="fullname" label="Nome completo" :required="true" v-model="fullname" v-if="!hidefullname" maxlength="255" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="6">
				<input-component name="email" label="E-mail" :required="true" :check="true" class="mb-0" v-model="email" maxlength="255" />
			</b-col>

			<b-col cols="12" md="6">
				<input-component
					name="phone"
					label="Telefone com DDD"
					:required="true"
					:check="true"
					:mask="phone.length > 14 ? '(##) #####-####' : '(##) ####-####'"
					class="mb-0"
					v-model="phone"
                    maxlength="20"
				/>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import InputComponent from "@/components/Form/Inputs/InputComponent";

export default {
	name: "ContactFormComponent",
	props: ["formKey", "canDelete", "formaux", "hidefullname"],
	components: {
		InputComponent,
	},
	mounted() {
        if (!this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].email) {
            return;
        }

        this.$v.$touch();
    },
	methods: {
		confirm() {
			this.$store.commit("setConfirmForm", {
				form: this.onlyKeyName,
				key: this.formKey,
			});

			this.$bvModal.show("modal-confirm");
		},
	},
	computed: {
		onlyKeyName() {
			return this.$vnode.key.replace(/[0-9]/g, "");
		},
		fullname: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].fullname;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "fullname",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		email: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].email;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "email",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		phone: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].phone;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "phone",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
	},
	validations: {
		fullname: {
			required
		},
		email: {
			required,
			email,
		},
		phone: {
			required,
			minLength: minLength(14),
		},
	},
};
</script>

<style lang="scss">
.form {
	border-radius: 8px;
	border: 2px solid #e7e7e7;
	padding: 40px 40px 15px 40px;
	margin: 20px 0;
	position: relative;
}

.delete {
	content: " ";
	top: -10px;
	right: -10px;
	width: 25px;
	z-index: 99;
	height: 25px;
	position: absolute;
	border-radius: 50%;
	background-color: #ed5417;
	cursor: pointer;
}

.delete::after {
	content: "−";
	color: white;
	position: absolute;
	font-weight: bold;
	margin-left: 0.45rem;
	margin-top: 0.1rem;
}
</style>
